export const Organization = `
<path class='path1' d='M716.8 307.2h51.2v51.2h-51.2v-51.2z'></path>
<path class='path2' d='M716.8 409.6h51.2v51.2h-51.2v-51.2z'></path>
<path class='path3' d='M716.8 512h51.2v51.2h-51.2v-51.2z'></path>
<path class='path4' d='M716.8 614.4h51.2v51.2h-51.2v-51.2z'></path>
<path class='path5' d='M716.8 819.2h51.2v51.2h-51.2v-51.2z'></path>
<path class='path6' d='M716.8 716.8h51.2v51.2h-51.2v-51.2z'></path>
<path class='path7' d='M307.2 307.2h51.2v51.2h-51.2v-51.2z'></path>
<path class='path8' d='M307.2 409.6h51.2v51.2h-51.2v-51.2z'></path>
<path class='path9' d='M307.2 512h51.2v51.2h-51.2v-51.2z'></path>
<path class='path10' d='M307.2 614.4h51.2v51.2h-51.2v-51.2z'></path>
<path class='path11' d='M307.2 819.2h51.2v51.2h-51.2v-51.2z'></path>
<path class='path12' d='M307.2 716.8h51.2v51.2h-51.2v-51.2z'></path>
<path class='path13' d='M204.8 307.2h51.2v51.2h-51.2v-51.2z'></path>
<path class='path14' d='M204.8 409.6h51.2v51.2h-51.2v-51.2z'></path>
<path class='path15' d='M204.8 512h51.2v51.2h-51.2v-51.2z'></path>
<path class='path16' d='M204.8 614.4h51.2v51.2h-51.2v-51.2z'></path>
<path class='path17' d='M204.8 819.2h51.2v51.2h-51.2v-51.2z'></path>
<path class='path18' d='M204.8 716.8h51.2v51.2h-51.2v-51.2z'></path>
<path class='path19' d='M409.6 307.2h51.2v51.2h-51.2v-51.2z'></path>
<path class='path20' d='M409.6 409.6h51.2v51.2h-51.2v-51.2z'></path>
<path class='path21' d='M409.6 512h51.2v51.2h-51.2v-51.2z'></path>
<path class='path22' d='M409.6 614.4h51.2v51.2h-51.2v-51.2z'></path>
<path class='path23' d='M409.6 819.2h51.2v51.2h-51.2v-51.2z'></path>
<path class='path24' d='M409.6 716.8h51.2v51.2h-51.2v-51.2z'></path>
<path class='path25' d='M947.2 972.8h-25.6v-691.2c0-39.058-29.024-79.326-66.077-91.677l-241.123-80.374v-83.949c0-8.093-3.827-15.709-10.318-20.539-6.493-4.829-14.888-6.306-22.637-3.981l-462.96 138.886c-37.73 11.32-67.285 51.043-67.285 90.434v742.4h-25.6c-14.138 0-25.6 11.461-25.6 25.6s11.462 25.6 25.6 25.6h921.6c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6zM839.333 238.496c16.259 5.419 31.067 25.965 31.067 43.104v691.2h-256v-809.282l224.933 74.978zM102.4 230.4c0-16.827 14.678-36.557 30.797-41.392l430.003-129.002v912.794h-460.8v-742.4z'></path>
`;



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/organization.js